import { Modal } from "react-bootstrap";
import { ReactComponent as ExitIcon } from "../../../assets/icons/NewPageSelector/exit-icon-close.svg";

import ILessonPageDto from "../../../models/ILessonPageDto";
import { useContext, useState } from "react";
import { PageContext } from "../../../routes/builderContexts";

import "./OutdatedMicroLessonModal.styles.css";

interface OutdatedMicroLessonModalProps {
  isOutdatedMicroLessonModalShown: boolean;
  setIsOutdatedMicroLessonModalShown: (isOutdatedMicroLessonModalShown: boolean) => void;
  microLesson: ILessonPageDto;
}

export function OutdatedMicroLessonModal({
  isOutdatedMicroLessonModalShown,
  setIsOutdatedMicroLessonModalShown,
  microLesson,
}: Readonly<OutdatedMicroLessonModalProps>) {
  const { updateMicroLesson } = useContext(PageContext);
  const [isLoading, setIsLoading] = useState(false);

  const { name, lessonPageId, referenceLessonId } = microLesson;

  function closeModal() {
    setIsOutdatedMicroLessonModalShown(false);
  }

  function handleUpdateMicroLesson() {
    setIsLoading(true);
    closeModal();

    updateMicroLesson(lessonPageId, referenceLessonId).finally(() => {
      setIsLoading(false);
    });
  }

  return (
    <>
      {isLoading && (
        <div className="loading-overlay" id="cpat">
          Updating Micro Lesson...
        </div>
      )}
      <Modal
        show={isOutdatedMicroLessonModalShown}
        onHide={() => setIsOutdatedMicroLessonModalShown(false)}
        dialogClassName="outdated-micro-lesson-modal"
      >
        <Modal.Header>
          <Modal.Title>Update Lesson Version</Modal.Title>
          <ExitIcon onClick={closeModal} />
        </Modal.Header>
        <Modal.Body>
          <p>A new version for {name} has been published. Do you wish to update to the latest lesson version?</p>
        </Modal.Body>
        <Modal.Footer>
          <div className="button-group-container">
            <button className="secondary" onClick={closeModal}>
              Cancel
            </button>
            <button className="primary" onClick={handleUpdateMicroLesson}>
              Update
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
